// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountSettingsSideMenu-listContainer-jw3TV {
  list-style-type: none;
}

.AccountSettingsSideMenu-sideNavitem-iXVH_ {
  display: block;
  padding: 8px 0;
  font-size: 16px;
  color: var(--secondary-foreground);
  text-decoration: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/AccountSettingsSideMenu/AccountSettingsSideMenu.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,gCAAgC;AAClC","sourcesContent":[".listContainer {\n  list-style-type: none;\n}\n\n.sideNavitem {\n  display: block;\n  padding: 8px 0;\n  font-size: 16px;\n  color: var(--secondary-foreground);\n  text-decoration: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listContainer": `AccountSettingsSideMenu-listContainer-jw3TV`,
	"sideNavitem": `AccountSettingsSideMenu-sideNavitem-iXVH_`
};
module.exports = ___CSS_LOADER_EXPORT___;
